export default {
  errors: {
    forbidden: "You don't have access to this report. Ask your administrator to enable it if you need it.",
    failed: 'The report could not be generated. Please try again in a few minutes.'
  },
  labels: {
    incidences_report: 'Incidences Report',
    pictures_report: 'Photos Report',
    sprint_report: 'Sprint Report',
    consolided_report: 'Consolidated Report',
    location_report: 'Route Report',
    quantitative_report: 'Quantitative Report',
    sales_report: 'Sales Report',
    soriana_report: 'Soriana Report',
    critical_points_report: 'Critical Points Report',
    general2_report: 'Praxair Report',
    cash_report: 'Cash Count Report',
    user_report: 'User Report',
    self_evaluation_report: 'Self-Evaluation Report',
    user_action_plans_report: 'Action Plans Report (User)',
    semaphore_report: 'Semaphore Report',
    executive_report: 'Executive Report',
    incidences_by_location: 'Incidences by Location Report',
    extras: 'Extra Fields Report',
    show_videos: 'Show Videos',
    show_photos: 'Show Photos',
    play_video: 'Play video'
  },
  general: 'General Report',
  incidences: 'Incidences Report',
  photos: 'Photos Report',
  quantitative: 'Quantitative Report',
  consolided: 'Consolidated Report',
  agenda_report: 'Agenda Report',
  user: 'Users Report',
  // Selector de usuarios en la configuración de reportes
  loading_users: 'Loading Users...',
  tasks: 'Tasks Report',
  sprints: 'Sprints Report',
  extras: 'Extra Fields Report',
  campaigns: 'Campaigns Report',
  self_evaluation: 'Self-Evaluation Report',
  cash: 'Cash Count Report',
  critical_points: 'Critical Points Report',
  location: 'Route Report',
  semaphore: 'Semaphore Report',
  executive: 'Executive Report',
  incidences_by_location: 'Incidences Report (Location)',
  general2: 'Praxair Report',
  category: 'Comprehensive Summary Report',
  category_toks: 'Comprehensive Summary Report (Toks)',
  workday: 'Quality Report',
  responsability_leadership: 'Responsibilities Report',
  calimax_workday: 'Calimax Comprehensive Audit Report',
  board: 'Dashboard Report',
  answers: 'Report by Item',
  consolidated_answers: 'Consolidated Item Report',
  follow_up: 'Follow-up Report',
  dimsa_rac: 'DIMSA RAC Report',
  form_by_scale: 'Form Evaluation Report',
  power_factor: 'Power Factor Report',
  fullfillment: 'Compliance Report',
  auditor_role: 'Forms Report by Auditor',
  resources: 'Resources Report',
  unified_incidences: 'Grouped Incidences Report',
  expiration: 'Expiration Report',
  caducity: 'Consolidation Report',
  management_report: 'Administrative Report',
  weighted_score: 'Weighted Report',
  executive_report: {
    answers: 'Answers',
    comments: 'Comments',
    pictures: 'Pictures',
    original: 'Original order',
    first_critical_points: 'Critical points first',
    first_no_critical_points: 'Non-critical points first'
  },
  non_executions_report: 'Non Executions Report',
  tables_report: 'Tables Report',
  forensic_audit: 'Forensic Audit Innova',
  planogram_report: 'Planogram Report',
  planogram_quality_report: 'Planogram Report (Quality)',
  daily: 'Daily Report',
  execution_time: 'Execution Time Report',
  administration_report: 'Administration Report',
  user_tracking_report: 'User Tracking Report',
  satisfaction_surveys: 'Voice Value Report',
  check_in: 'Check-In Report',
  planogram_table_report: 'Planogram Report (Table)',
  planogram_table: {
    area: 'Area',
    planogram: 'Planogram',
    auditor: 'Auditor',
    date: 'Date',
    score: 'Score',
    consolidated: 'Consolidated',
    legend_no: '0 = DOES NOT COMPLY / NOT APPLIED / FALSE',
    legend_yes: '1 = COMPLIES / APPLIED / TRUE',
    evaluations: 'evaluations',
    auditors: 'Auditors',
    manager_placeholder: '[Store manager name]',
    no_results: 'There are no closed planogram evaluations in the selected period.',
    skipped_forms: 'Forms without planogram structure (skipped)'
  },
  attendance: 'Attendance Report',
  attendance_report: {
    title: 'Attendance Report',
    user: 'User',
    location: 'Location',
    total_records: 'Users',
    period_days: 'Days in period',
    download_excel: 'Download Excel',
    forms_used: 'Forms used',
    not_detected: 'not detected',
    legend: 'Legend',
    no_results: 'No attendance for the selected filters.',
    workdays: 'Workdays',
    lates: 'Late arrivals',
    omitted_entries: 'AO',
    absences: 'Absences',
    rests: 'Rest days',
    sunday_premiums: 'Sunday premium',
    form_roles: {
      check_in: 'On-time check-in',
      late_check_in: 'Late check-in',
      lunch: 'Lunch break',
      check_out: 'Check-out'
    },
    codes: {
      attendance: 'Attendance',
      late: 'Late arrival',
      omitted_entry: 'Attendance with omitted entry',
      absence: 'Absence',
      rest: 'Rest day',
      undetermined: 'No reliable schedule'
    }
  },
  merma_harvest: 'Shrinkage / Harvest Report',
  exhibitions: 'Exhibitions Report',
  check_in_report: {
    title: 'Check-In Report',
    user: 'User',
    location: 'Location',
    hierarchy: 'Zone / Hierarchy',
    date: 'Date',
    time: 'Check-In Time',
    latitude: 'Latitude',
    longitude: 'Longitude',
    address: 'Address',
    perimeter: 'Perimeter',
    distance: 'Distance (m)',
    inside: 'Inside',
    outside: 'Outside',
    not_applicable: 'N/A',
    no_results: 'No check-ins for the selected filters.',
    total_records: 'Total records'
  },
  // Metricas y stats del reporte de tareas
  select_locations: 'Selected locations',
  completed: 'Completed',
  in_process: 'In progress',
  expired: 'Expired',
  total: 'Total',
  last_trimester_tasks: 'Tasks from last quarter',
  created: 'Created',
  created_at: 'Created',
  suspended: 'Suspended',
  location_tasks: 'Tasks by location',
  time: 'On time',
  in_progress: 'In progress',
  out_of_time: 'Out of time',
  in_progress_out_time: 'Expired',
  completed_on_time: 'Completed on time',
  completed_out_time: 'Completed out of time',
  // Estados de tarea usados en el dialogo de reporte
  report: {
    assigned: 'assigned',
    finished: 'finished',
    suspended: 'suspended'
  },
  // Labels del dialogo de detalle de reporte de tarea
  dialog_report: {
    assigned_to: 'Assigned to',
    today: 'Today',
    days: 'days',
    day: 'day',
    category: 'Category'
  },
  // Texto de graficos del reporte de tareas por categoria/area
  graphOptions: {
    tasks_by_category: 'Tasks by category',
    tasks_by_area: 'Tasks by area'
  },
  // Columnas del dialogo de configuracion de la tabla de tareas, compartido con Torre de Control
  columnsDialog: {
    title: 'Title',
    created_by: 'Created by',
    assigned_to: 'Assigned to',
    update_at: 'Last modified',
    end_date: 'Due date',
    category: 'Category',
    state: 'Status'
  },
  // Columnas de titulo (usuario/ubicacion) del reporte de tareas
  titleColum: {
    user: 'User',
    location: 'Location'
  },
  download: {
    title: 'Download type',
    browser: 'Download in Browser',
    email_link: 'Link by Email',
    email_send: 'Send by Email',
    local: 'Local Download',
    started_email: 'The export has started. You will receive an email when it is ready.',
    started_notification: 'The export has started. We will notify you in the notifications panel when it is ready.',
    error: 'The export could not be requested. Please try again.'
  },
  pdf_export: {
    title: 'General Report PDF',
    selection: 'Locations: {locations} · Forms: {forms}',
    fallback: 'This report is larger than expected, so we will generate it in the background.',
    generating: 'Generating PDF…',
    ready: 'PDF ready, downloading…',
    closed_hint: 'You can close this window: we will let you know in notifications when it is ready.',
    close: 'Close',
    downloaded: 'PDF downloaded',
    sent_to_notifications: 'Your PDF is ready: we sent it to your notifications.',
    file_error: 'The PDF could not be downloaded. We will send it to your notifications so you can download it from there.',
    error_failed: 'The PDF could not be generated. Please try again in a few minutes.',
    error_timeout: 'Generating the PDF took too long and was stopped. Try with fewer locations or forms.',
    error_rate_limited: 'You already have several exports in progress. Please try again in {minutes} min.',
    error_unexpected: 'The PDF could not be generated. Please try again.'
  }
}
